module.exports = __webpack_public_path__ + "img/TCALCI_broad_male_95.0dc617ee.png";